import {TranslationObject} from '@colonist/i18n'
import {ProfileEditAjaxEndPoints} from '../profile/ProfileEditAjaxEndPoints'
import {UIProfileUsernameController} from '../ui_html/header/UIProfileUsernameController'
import {ViewPopup} from './ViewPopup'
import {Sound} from '../Sound'
import {UIPopupController} from './UIPopupController'

export class ViewPopupChangeOnlineUsername extends UIProfileUsernameController {
    private readonly continuationAction: () => void

    constructor(continuationAction: () => void) {
        const title: TranslationObject = {key: 'strings:homePage.header.changeUsername.title', options: {context: 'onlineUsername'}}
        const body: TranslationObject = {key: 'strings:homePage.header.changeUsername.body', options: {context: 'onlineUsername'}}

        super(title, body)

        this.continuationAction = continuationAction

        this.xButton.onclick = () => {
            Sound.playSound(Sound.SoundType.Click)
            this.removePopup()
            this.continuationAction()
        }

        this.setFocusStyles(this.input)
        this.show()
    }

    // eslint-disable-next-line class-methods-use-this
    async updateUsername(newUsername: string, shouldPurchaseIfNoAttemptsLeft: boolean = false) {
        const success = await ProfileEditAjaxEndPoints.updateUsername(newUsername, shouldPurchaseIfNoAttemptsLeft)
        if(!success) return
        this.showSuccessPopup(newUsername)
    }

    protected checkAction() {
        Sound.playSound(Sound.SoundType.Click)
        if(!this.inputLengthIsInRange()) return

        this.inputCheckAction(this.input.value)
    }

    protected showConfirmUsernameChangeWithAttemptsLeftPopup(username: string) {
        const body: TranslationObject = {
            key: 'strings:homePage.header.changeUsername.confirm.body',
            options: {count: this.state.usernameChangeAttemptsLeft - 1},
        }
        UIPopupController.create({key: 'strings:homePage.header.changeUsername.confirm.title'}, body,
            () => {
                void this.updateUsername(username, false)
            },
            () => undefined)
    }

    private showSuccessPopup(newUsername: string) {
        this.removePopup()

        const title: TranslationObject = {key: 'strings:storePage.success.success'}
        const body: TranslationObject = {
            key: 'strings:homePage.header.changeUsername.successDiscord',
            options: {
                username: newUsername,
            },
        }

        const successPopup = new ViewPopup(title, body, () => undefined, () => undefined, true, {showXButton: false})
        successPopup.removeAction = this.continuationAction
        successPopup.show()
    }
}
